<template lang="html">
  <ul>
    <li class="" v-for="(project, index) in projects" :key="index">
      <cw-project-cell
        :project="project"
        @click="selectionHandler(project)"
        :showDisclosureIndicator="showDisclosureIndicators"
        :showSelectedIndicator="project.projectId === selectedProjectId"
        :iconProps="cellIconProps"
      />
      <!-- <cw-box-list :boxes="project.currentDispatchSets || []" :selectionHandler="itemSelected"/> -->
    </li>
  </ul>
</template>

<script>
export default {
  name: 'cw-project-list',
  mixins: [],
  props: {
    projects: {
      type: Array,
      required: true,
    },
    selectionHandler: {
      type: Function,
      required: false,
      default: () => {},
    },
    selectedProjectId: {
      type: String,
      required: false,
      default: '',
    },
    showDisclosureIndicators: {
      type: Boolean,
      required: false,
      default: true,
    },
    cellIconProps: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: 'pin',
          scale: 2,
          colorClass: 'has-text-grey-light',
        };
      },
    },
  },
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="css"></style>
